(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-pro-sticky-shop"] && !Shopify.designMode) return;
  try {
    (() => {
  const bar = document.querySelector('[data-fspro-sticky]');
  if (!bar) return;
  const purchase = document.querySelector('.fspro-hero__inner') || document.querySelector('.product__info-container');
  const footer = document.querySelector('.footer');
  let nearFooter = false;
  let scheduled = false;
  const paint = () => {
    const passedPurchase = purchase ? purchase.getBoundingClientRect().bottom < 0 : window.scrollY > 850;
    bar.hidden = !passedPurchase || nearFooter;
    scheduled = false;
  };
  window.addEventListener('scroll', () => {if (!scheduled) {scheduled = true; requestAnimationFrame(paint);}}, {passive: true});
  window.addEventListener('resize', paint, {passive: true});
  if (footer && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      nearFooter = entries[0].isIntersecting;
      paint();
    });
    observer.observe(footer);
  }
  paint();
})();
  } catch(e) { console.error(e); }
})();

})();
